export default __webpack_public_path__ + "static/B0189-df1c87e968ba5ab992c15e64acca24f5.png";